import React, { useState } from 'react';
import { useTheme } from 'react-jss';
import { slide as Menu } from 'react-burger-menu';

const getMenuStyles = ({ theme, collapsed }) => ({
    bmBurgerButton: {
        display: 'none' // Hide the default burger button since we have our custom toggle
    },
    bmBurgerBars: {
        background: theme.color.veryDarkGreenishVibe
    },
    bmBurgerBarsHover: {
        background: theme.color.darkRed
    },
    bmCrossButton: {
        display: 'none'
    },
    bmCross: {
        background: theme.color.greenishVibe3
    },
    bmMenuWrap: {
        position: 'fixed',
        height: '100%',
        width: collapsed ? 80 : 255,
        zIndex: 30,
        transition: 'width 0.3s ease'
    },
    bmMenu: {
        background: `linear-gradient(180deg, ${theme.color.veryDarkGreenishVibe} 0%, ${theme.color.green02} 100%)`,
        backdropFilter: 'blur(20px)',
        borderRight: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '4px 0 20px rgba(0, 0, 0, 0.1)'
    },
    bmItem: {
        outline: 'none',
        '&:focus': {
            outline: 'none'
        }
    },
    bmMorphShape: {
        fill: theme.color.veryDarkGreenishVibe
    },
    bmOverlay: {
        background: 'rgba(0, 0, 0, 0.3)',
        zIndex: 20
    }
});

function MenuComponent({ children, isMobile, collapsed = false }) {
    const theme = useTheme();
    const menuStyles = getMenuStyles({ theme, collapsed });
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Menu
            isOpen={!isMobile || isOpen}
            noOverlay={!isMobile}
            disableCloseOnEsc
            styles={menuStyles}
            onStateChange={(state) => setIsOpen(state.isOpen)}
        >
            {children}
        </Menu>
    );
}

export default MenuComponent;
